import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { formatTimeToStr } from "@/utils/data";
import { formatDate } from "@/utils/dateConvert.js";
import infoList from "@/components/mixins/infoList";
import { getQeDashConfigById } from "@/api/qe_dash_config";
import { qeDymTableListByParam, qeDymTableAddOrUpdate, qeDymTableDeleteById } from "@/api/qe_dym_table_opt";
export default {
  name: "formCard",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: qeDymTableListByParam,
      tableLoading: false,
      tableData: [],
      cardConfig: {},
      searchInfo: {},
      dialogFormVisible: false,
      dialogTitle: "",
      formData: {},
      rules: {}
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.mounturl();

            // 根据id查询配置
            this.getConfigById();

            //查询数据
            this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: {
    tableColumns: function tableColumns() {
      if (!this.cardConfig) {
        return [];
      }
      if (!this.cardConfig.fields) {
        return [];
      }
      var tableColumns = [];
      this.cardConfig.fields.forEach(function (item) {
        if (item.tableOption) {
          tableColumns.push(item);
        }
      });
      return tableColumns;
    },
    formItems: function formItems() {
      if (!this.cardConfig) {
        return [];
      }
      if (!this.cardConfig.fields) {
        return [];
      }
      var formItems = [];
      this.cardConfig.fields.forEach(function (item) {
        if (item.formOption) {
          formItems.push(item);
        }
      });
      return formItems;
    }
  },
  watch: {
    $route: {
      handler: function handler() {
        this.mounturl();

        // 根据id查询配置
        this.getConfigById();

        //查询数据
        this.getTableData();
      },
      deep: true
    }
  },
  methods: {
    getConfigById: function getConfigById() {
      var _this = this;
      // 根据id查询配置
      getQeDashConfigById({
        ID: this.searchInfo.configId
      }).then(function (res) {
        if (res.code == 0) {
          _this.cardConfig = JSON.parse(res.data.data);

          //这里要设置下，否则多个Tab共享了一个formData
          _this.formData = {};

          //初始化 formData
          _this.cardConfig.fields.forEach(function (item) {
            // 初始化formData
            _this.initiateFormData(item);

            //初始化rules
            _this.initiateRules(item);
          });
        }
      });
    },
    //初始化formData
    initiateFormData: function initiateFormData(item) {
      if (item.formOption) {
        // 这里不能用 this.formData[item.key]=null，否则双向绑定失效
        this.$set(this.formData, item.key, null);
      }
    },
    //初始化rules
    initiateRules: function initiateRules(item) {
      if (item.formOption) {
        var rule = [];
        if (item.formOption.required) {
          rule.push({
            required: true,
            message: item.formOption.requiredDesc,
            trigger: "blur"
          });
        }
        rule.push({
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
              return;
            }
            if (item.formOption.limitLength) {
              var min = item.formOption.limitLength.min;
              var max = item.formOption.limitLength.max;
              var limitDesc = item.formOption.limitLength.limitDesc;
              if ((value + "").length < min || (value + "").length > max) {
                return callback(new Error(limitDesc));
              }
            }
            if (item.formOption.limitType) {
              var type = item.formOption.limitType.type;
              var _limitDesc = item.formOption.limitType.limitDesc;
              if (type === "number") {
                var reg = new RegExp("^[0-9]*$");
                if (!reg.test(value)) {
                  return callback(new Error(_limitDesc));
                }
              }
            }
            callback();
          },
          trigger: "blur"
        });
        this.$set(this.rules, item.key, rule);
      }
    },
    mounturl: function () {
      var _mounturl = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.searchInfo.configId = Number(window.atob(this.$route.params.body));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function mounturl() {
        return _mounturl.apply(this, arguments);
      }
      return mounturl;
    }(),
    // 添加一行数据
    addOne: function addOne() {
      this.formData.ID = null;
      this.dialogFormVisible = true;
      this.dialogTitle = "新增";
    },
    updateOne: function () {
      var _updateOne = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var key;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.dialogFormVisible = true;
              this.dialogTitle = "修改";
              // 设置参数
              for (key in this.formData) {
                // 检查属性是否是对象自身的（而非继承的）
                if (this.formData.hasOwnProperty(key) && row.hasOwnProperty(key)) {
                  this.formData[key] = row[key];
                }
              }
              this.formData.ID = row.ID;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateOne(_x) {
        return _updateOne.apply(this, arguments);
      }
      return updateOne;
    }(),
    deleteOne: function () {
      var _deleteOne = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.formData.ID = row.ID;
              this.formData.configId = this.searchInfo.configId;
              _context5.next = 1;
              return qeDymTableDeleteById(this.formData);
            case 1:
              res = _context5.sent;
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: this.$t("common.success")
                });
                this.getTableData();
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deleteOne(_x2) {
        return _deleteOne.apply(this, arguments);
      }
      return deleteOne;
    }(),
    //关闭浮层
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      //取消表单之前的校验状态
      this.$refs.qeTableParamForm.resetFields();

      // 置空 formData
      for (var key in this.formData) {
        // 检查属性是否是对象自身的（而非继承的）
        if (this.formData.hasOwnProperty(key)) {
          this.formData[key] = null;
        }
      }
      this.formData.ID = null;
    },
    // 浮层保存
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;
        var key;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.formData.configId = this.searchInfo.configId;

              //采用双向绑定的方式去掉formData的首尾空格
              for (key in this.formData) {
                // 检查属性是否是对象自身的（而非继承的）
                if (this.formData.hasOwnProperty(key) && this.formData[key]) {
                  if (this.formData[key] && typeof this.formData[key] === "string") {
                    this.$set(this.formData, key, this.formData[key].trim());
                  }
                }
              }
              this.$refs.qeTableParamForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!valid) {
                          _context6.next = 2;
                          break;
                        }
                        _context6.next = 1;
                        return qeDymTableAddOrUpdate(_this2.formData);
                      case 1:
                        res = _context6.sent;
                        if (!(res.code == 0)) {
                          _context6.next = 2;
                          break;
                        }
                        _this2.$message({
                          type: "success",
                          message: "success"
                        });
                        _this2.closeDialog();
                        _context6.next = 2;
                        return _this2.getTableData();
                      case 2:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    // 格式化table的列值
    formatterColumnValue: function formatterColumnValue(scope, col) {
      var value = scope.row[col.key];
      if (!value) {
        return value;
      }
      if (col.type === "date") {
        return formatDate(value, col.timeCondition.tableFormat, col.timeCondition.showFormat);
      } else if (col.type === "time") {
        var date = new Date(value);
        return formatTimeToStr(date, col.timeCondition.showFormat);
      } else {
        return value;
      }
    }
  }
};